import StoredLayout from '../../layouts/StoredLayout'
import Buttons from './Buttons'
export default StoredLayout(Buttons)
